import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import featureToggles from '../../../utils/featureToggles';
import ComingSoonPage from '../comingSoonPage';
import archiveImages from '../../../assets/static-data/2021/archiveImages.json';
import { renderListOfImageCards } from '../../archiveImageCard/archiveImageCardUtils';

const ArchivePage2021 = () => {

  const [archiveImageList, setArchiveImageList] = useState(archiveImages);
  const { t } = useTranslation();

  useEffect(() => {
    if (!archiveImageList) {
      setArchiveImageList(archiveImages);
    }
  }, []);

  useEffect(() => {
    document.title = t('Pages.Archive2021.Title');
  }, []);

  if (!featureToggles.archive()) {
    return <ComingSoonPage title={t('Pages.Archive2021.Title')} header={t('Pages.Archive2021.Header')} />;
  }

  return (
    <div className="con-container">
      <div className="con-content">
        <div className="con-flex__container">
          <h1 className="con-heading con-heading__l--margin-bottom-3">{t('Pages.Archive2021.Header')}</h1>
        </div>
        <div className="con-archive-button__wrap">
          <a className="con-archive__button" href="https://www.youtube.com/watch?v=f4uU6PWHF48">{t('Pages.Archive2021.AIConVideo1Button')}</a>
        </div>
        {renderListOfImageCards(archiveImageList)}
      </div>
    </div>
  );
};

export default ArchivePage2021;
